import { Component, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { DialogService, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { EnergyExportDialogComponent } from "../../energy-export-dialog/energy-export-dialog.component";
import { MessageService } from "@openng/optimus-ui/api";

@Component({
  selector: "app-energy-export",
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: "./energy-export.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./energy-export.component.scss",
})
export class EnergyExportComponent {
  public assetId = input<string>();
  public assetType = input<string>();
  public assetLabel = input<string>();

  private dialogService = inject(DialogService);
  private ref: DynamicDialogRef | null = null;
  private translate = inject(TranslateService);
  private message = inject(MessageService);

  /**
   * Opens the energy export dialog.
   * The dialog is provided with the assetId, assetType and assetLabel as data.
   */
  public startExport() {
    this.ref = this.dialogService.open<EnergyExportDialogComponent>(EnergyExportDialogComponent, {
      header: `${this.translate.instant("energy_tool.energy_export.dialog_header")} ${this.translate.instant("asset_types." + this.assetType())}: ${this.assetLabel()}`,
      modal: true,
      focusOnShow: false,
      width: "700px",
      contentStyle: { overflow: "auto" },
      data: {
        assetId: this.assetId(),
        assetType: this.assetType(),
        assetLabel: this.assetLabel(),
      },
      closable: true,
    });

    this.ref?.onClose.subscribe((success: boolean) => {
      if (success) {
        this.message.add({
          key: "global",
          severity: "success",
          summary: this.translate.instant("common.success"),
          detail: this.translate.instant("energy_tool.energy_export.success_message"),
          life: 4500,
        });
      }
    });
  }
}
